export default class ConfiguratorModal extends HTMLElement {
  #abortController;
  #main
  #contentType = 'content';

  constructor() {
    super();
    this.NAME = `ConfiguratorModal`;
    let template = document.getElementById('configurator-modal-template');
    let templateContent = template.content;
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(templateContent.cloneNode(true));
    this.#main = this.shadowRoot.querySelector('main');
    this.closeBtn = this.shadowRoot.querySelector('[data-close-btn]');
  }

  connectedCallback() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.closeBtn.addEventListener('click', () => this.dataset.show = 'false', { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['content-type', 'data-show', 'data-product-variant-id', 'modal-style'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    /* console.log(this.NAME, name, oldValue, newValue); */
    switch (name) {
      case 'data-show':
        this.#dispatchCustomEvent(newValue === 'false' ? 'close' : 'open');
        break;

      case 'content-type':
        this.#contentType = newValue;
        if (newValue === 'form') {
          this.#addFormListeners();
        }
        if (newValue == 'product') {
          this.content = this.querySelector('[slot="modal-content"]');
          this.info = this.content.querySelector('[data-info]');
          this.img = this.content.querySelector('img');
        }
        if (newValue == 'confirm' || newValue == 'content') {
          this.content = this.querySelector('[slot="modal-content"]');
          this.#addButtonListeners();
        }
        break;
      
      case 'data-product-variant-id':
        if (newValue && newValue !== '') {
          this.#populateProductInfo(newValue);
        }
        break;

      case 'modal-style':
        if (newValue && newValue !== '') {
          this.#main.setAttribute('style', newValue);
        }
        break;
    
      default:
        break;
    }
  }

  #populateProductInfo(variantId) {
    this.productVaraintID = variantId;
    this.imgSrc = document.getElementById(`img-${this.productVaraintID}`)?.src;
    let el = document.getElementById(`template-${this.productVaraintID}`);
    this.info.innerHTML = el.innerHTML;
    this.img.src = '';
    if (this.imgSrc) this.img.src = this.imgSrc.split('&width')[0] + '&width=600';
    this.#addProductListeners();
    this.#addFormListeners();
  }

  #addButtonListeners() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    const btns = this.content.querySelectorAll('button');
    //
    btns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (this.#contentType === 'confirm') this.dataset.show = 'false';
        this.#dispatchCustomEvent(e.target.name);
      }, { signal });
    });
  }

  #addProductListeners() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    const btn = this.content.querySelector('[name][data-select-product-btn]');
    const input = this.content.querySelector('[data-update-quantity-input]');
    //
    if (btn) btn.addEventListener('click', (e) => {
      const data = {
        variantId: e.target.dataset.productVariant,
        price: e.target.dataset.productPrice,
        title: e.target.dataset.productTitle,
        image: this.imgSrc
      }
      this.#dispatchCustomEvent(e.target.name, data);
      btn.dataset.selected = true;
      if (input) input.value = 1;
    }, { signal });
    //
    if (input) {
      input.addEventListener('input', (e) => {
        const data = {
          variantId: e.target.dataset.productVariant,
          quantity: e.target.value
        }
        this.#dispatchCustomEvent(e.target.name, data);
        if (e.target.value == 0) btn.dataset.selected = false;
      }, { signal });
    }
  }

  #addFormListeners() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.form = this.querySelector('form');
    const btn = this.form?.querySelector('[type="button"]');
    //
    if (this.form) this.form.addEventListener('submit', (e) => this.#onFormSubmit(e), { signal });
    //
    if (btn) btn.addEventListener('click', (e) => this.#dispatchCustomEvent(e.target.name), { signal });
  }

  #onFormSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);
    const value = Object.fromEntries(data.entries());
    if (this.imgSrc) value.image = this.imgSrc;
    this.#dispatchCustomEvent('form data', value);
  }

  #dispatchCustomEvent(name, otherData = {}) {
    /* console.log('#dispatchCustomEvent', name, otherData); */
    const event = new CustomEvent('modalevent', {
      detail: {
        name,
        ...otherData
      },
    });
    this.dispatchEvent(event);
  }
}

customElements.define('configurator-modal', ConfiguratorModal);